export class FormData {

  constructor(scheme, properties = {}, data){
    this.scheme = scheme
    this._properties = properties

    if (!data){
      this.data = this._emptyData()
    } else {
      this.leftEmpty = scheme.canLeftEmpty && data.leftEmpty || false
      if (Array.isArray(data)) {
        this.data = data
      } else {
        this.data = data.data
      }
      this.objectData = data
    }

    if (properties.calculateAuto) {
      this._calculateAuto()
    }
    this._calculateSummary()
  }

  setLeftEmpty(value){
    this.leftEmpty = value
  }

  setValue(row, column, value){
    this.data[row][column] = value
    this._calculateAuto()
    this._calculateSummary()
  }

  createRow(){
    SchemeUtils.createRow(this.scheme, this.data)
    this._calculateAuto()
  }

  deleteRow(rowIndex){
    this.data.splice(rowIndex, 1)
    this._calculateAuto()
    this._calculateSummary()
  }

  _calculateAuto(){
    if (this._properties.calculateAuto)
      SchemeUtils.calculateAuto(this.scheme, this.data)
  }

  _calculateSummary(){
    this.summary = SchemeUtils.calculateSummary(this.scheme, this.data)
  }

  _emptyData(){
    return this._properties.createEmptyRow?SchemeUtils.emptyDataFor(this.scheme):[]
  }

  data(){
    return this.objectData;
  }
}

export class FormGroupDatas {
  constructor(scheme, properties, groups){
    this.scheme = scheme
    this._properties = properties

    if (!groups){
      this.groups = [new FormGroupData(scheme, properties)]
    } else {
      this.groups = groups
    }

    // let onChange = this._calculateSummary
    //let calculateSummary = this._calculateSummary
    this.groups.forEach((group) => {/*console.log(this);*/this._bindChangeHandler(group)})

    this._calculateSummary()
  }

  setLeftEmpty(value){
    throw "Unsupported operation"
  }

  createGroup(){
    let group = new FormGroupData(this.scheme, this._properties)
    this._bindChangeHandler(group)
     this.groups.push(
        group
     )
     this._calculateSummary()
  }

  deleteGroup(groupIndex){
    this.groups.splice(groupIndex, 1)
    this._calculateSummary()
  }

  _bindChangeHandler(group){
    group.onChange = (function(){
      this._calculateSummary()
    }).bind(this)
  }

  _calculateSummary(){
    this.summary = 
      SchemeUtils.calculateSummary(this.scheme, this.data())
  }

  data(){
    return ArrayUtils.flat(this.groups.map((group) => {return group.data})) 
  }
}

export const ArrayUtils = {
  mapWithFilter: function(array, filter, mapping){
    return array.reduce(
      (result, element, index) => {
        if (filter(element)) {
          result.push(mapping(element, index, result.length, array))
        } 
        return result
    }, [])
  },

  range: function(min, max){
    const arr = []
    for (let i = min; i <= max; i++){
      arr.push(i)
    }
    return arr;
  },

  flat: function(arrays){
    return [].concat.apply([], arrays);
  },

  last: function(array){
    return array[array.length - 1]
  }
}

export class FormGroupData extends FormData {
  constructor(scheme, properties = {}, data){
    super(scheme, properties, data)
    this.groupHeader = ""
  }

  setValue(row, column, value){
    if (row === -1)
      this.groupHeader = value
    else
      super.setValue(row, column, value)

    this._fireChange()
  }

  createRow(){
    super.createRow()
    this._fireChange()
  }

  deleteRow(rowIndex){
    super.deleteRow(rowIndex)
    this._fireChange()
  }

  _fireChange(){
    this.onChange&&this.onChange()
  }

  static _splitDataOnGroups(data){
      let sign = ArrayUtils.last(data[0])
      let groups = []
      let group = []
      for (let i = 0; i < data.length;++i) {
        if (sign == ArrayUtils.last(data[i])) {
          group.push(data[i])
        } else {
          groups.push(group)
          group = []
          sign = ArrayUtils.last(data[i])
        }
      }
      return groups;
  }

  static from(scheme,  properties, data) {
    if (!data || (data.length == 0 && properties.createEmptyRow)) {
      return [new FormGroupData(scheme, properties)]
    } else {
      let groups = this._splitDataOnGroups(data)
      return groups.map((group) => {return new FormGroupData(scheme, properties, properties)})
    }

  }
}

export const SchemeUtils = {
  _colSpan: function(element){
    return element.children?element.children.reduce((sum, child) => sum + this._colSpan(child), 0):1
  },

  _preprocessHeaders: function(array, columnIndexShift = 0){
      if (array.some(element => !element.isVirtual)){
        let children = ArrayUtils.flat(array.map((element) => {
          return (element.isVirtual?[element]:(
            element.children?element.children:[{
              "isVirtual": true, 
              "columnWidth": 
                Math.max(...element.label.split(" ").map(word => word.length + 4)),
              "auto": element.auto,
              "summary": element.summary,
              "validator": element.validator,
              "ref": element.ref,
              "merge" : element.merge,
              "readOnly": element.readOnly
            }]
          ))
        }))//.flat()
        let rows = this._preprocessHeaders(children, columnIndexShift)
        let row = 
        ArrayUtils.mapWithFilter(array, element => !element.isVirtual, element => {
          return {
            label: element.label, 
            colspan: this._colSpan(element), 
            rowspan: (element.children?1:rows.length),
            width: Math.max(...element.label.split(" ").map(word => word.length + 2)),
            ref: element.ref
          }
        })
        return [row].concat(rows)
      } else {
        return [array.map(
          (element, index) => {
            return {
              label: index + 1 + columnIndexShift, colspan: 1, rowspan: 1,
              columnWidth: element.columnWidth,
              columnIndex: index + columnIndexShift,
              validator: element.validator,
              summary: element.summary,
              auto: element.auto,
              merge: (element.merge===true)?1:(element.merge?element.merge: 0),
              readOnly: element.readOnly || false
            }
          }
        )]
      }
    },

  preprocess : function(scheme) {
    let processed = {
        "id": scheme.id,
        "label": scheme.label,
        "canLeftEmpty": scheme.canLeftEmpty || false,
        "ref" : scheme.ref,
        "summary": scheme.summary,
        "group": scheme.group,
        "emptyRowUnderHeader": scheme.emptyRowUnderHeader,
        "fixedRowNumber": scheme.fixedRowNumber || false
      };
    if (scheme.sections) {
      //let headers = this._preprocessHeaders(scheme.sections[0].headers)
      processed.sections = scheme.sections.reduce((processed, section) => {
        let headers = SchemeUtils._preprocessHeaders(section.headers, processed.columnIndexShift)
        processed.sections.push({"headers":headers, "widths":section.widths})//{"headers":headers, "columnIndexShift": columnIndexShift})
        processed.columnIndexShift += headers[headers.length - 1].length
        return processed
      }, {"sections": [], columnIndexShift : 0}).sections
    } else {
      let headers = this._preprocessHeaders(scheme.headers)
      processed.sections = [{"headers":headers, "widths":scheme.widths}]
    }
    return processed;
  },

  emptyDataFor: function(scheme) {
    return this.createRow(scheme)
  },

  calculateSummary: function(scheme, data) {
    return scheme.summary?ArrayUtils.flat(
      scheme.sections.map(
        section => {
          return section.headers[section.headers.length - 1]
        }
      )
    ).map((column, index) => {
      return column.summary?
        (typeof(column.summary) == "string"?column.summary:column.summary(index, data)):""
    }):[]
  },

  calculateAuto: function(scheme, data) {
    let columns = ArrayUtils.flat(scheme.sections.map(section => {
      return section.headers[section.headers.length - 1]
    }))
    for (let i = 0; i < data.length; ++i){
      let row = data[i]
      for (let j = 0; j < Math.min(row.length, columns.length); ++j) {
        row[j] = (columns[j].auto&&columns[j].auto({row: i, column: j}, data)) || row[j]
      }
    }
  },

  createRow: function(scheme, data = []) {
    let columns = ArrayUtils.flat(scheme.sections.map(section => {
      return section.headers[section.headers.length - 1]
    }))
    let row = Array(columns.length).fill("")
    data.push(row)
    this.calculateAuto(scheme, data)
    // data.push(ArrayUtils.flat(scheme.sections.map(section => {
    //   return section.headers[section.headers.length - 1]
    // })).flat().map((column, index) => {
    //   return (column.auto && column.auto({row: data.length, column: index}, data.concat)) || ""
    // }))
    return data
  }
}



export let ReferenceUtils = {
  extract: (references, path) => {
    return references[path[0] - 1]?(
      references[path[0] - 1][path[1] - 1]?references[path[0] - 1][path[1] - 1]:""
    ):""
  }
}

export let commonValidators = {
  number: function(str){
    return /^\d+$/.test(str)
  },
  rational: function(str){
    return /^((\d+)|(\d+\.\d*))$/.test(str)
  },
  and: function(left, right){
    return function(str){
      left(str)&&right(str)
    }
  }
}

export let commonHeaders = {
  numbnerInOrder : {
    "label": "N п/п",
    "auto": (position) => {return position.row + 1}, 
    "validator": commonValidators.number
  },
  measureUnit : (unit) => {
    let header = {
      "label": "Единица измерения",
    }
    if (!(unit === undefined)) {
      header.auto = commonHeaders.defaultValue(unit)
    }
    return header
  },
  yearsRange: (start, finish)=>{
    return ArrayUtils.range(start, finish).map(year => {
      return {"label": String(year)}
    })
  },
  defaultValue: (value) => {
    return () => {return value}
  }
}

export let commonSummaries = {
  columnTotal: (column, data)=>{
    return data.some((row) => {return row[column] && String(row[column]).trim()})?String(
      data.reduce((sum, row) => {
        return sum + (row[column] && String(row[column]).trim()?parseFloat(row[column]): 0)
      }, 0)
    ):""
  },

  rowSummary: (indexes) => {
    return (position, data)=>{
      return indexes.some((index) => {return data[position.row][index] && String(data[position.row][index]).trim()})?String(
      indexes.reduce((sum, index) => {
        return sum + (data[position.row][index] && String(data[position.row][index].trim())?parseFloat(data[position.row][index]): 0)
      }, 0)):""
    }
  }
}


export const tables = function tables(baseYear, kerRange) {
   const withValidator = function(array, validator){
    return array.map((element)=>{
      element.validator = validator
      return element
    })
  }

};

export const references = [
    //1
    [
      "В соответствии с общероссийским классификатором продукции по видам экономической деятельности ОКПД2, при их наличии.", 
      "Указываются сведения на планируемый период действия комплексного экологического разрешения. Сведения представляются с учетом планирования увеличения мощности по отношению к максимальной указанной в графе 5 таблицы 1.1 или сокращения мощности (например, вывода мощностей из эксплуатации).", 
      "В таблице приводятся сведения о всех видах сырья и материалов, которые используются для производства продукции, указанной в таблице 1.1.", 
      "Представляются сведения об использовании воды, забранной из природных источников и (или) полученной от поставщиков на планируемый период действия комплексного экологического разрешения.", 
    ],
    //2
    [
      "В разделе приводятся сведения об авариях и инцидентах, произошедших за предыдущие семь лет.",
      "Последствия приводятся с указанием количественных параметров, в том числе приводятся данные о площади загрязненных земель, акватории, степени загрязнения почвы, массах выброшенных или сброшенных загрязняющих веществ.",
      "Заполняется при наличии утвержденной и реализуемой программы повышения экологической эффективности."
    ],
    //3
    [
      "Графа заполняется, если для технологии, указанной в графе 3, установлены технологические показатели НДТ в соответствии с пунктом 3 статьи 23 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\".",
      "В графе приводятся количественные и качественные показатели, которые обеспечиваются технологией, показатели воздействия на окружающую среду которой не превышают установленные технологические показатели НДТ, в том числе по следующим направлениям: снижение ресурсопотребления, снижение негативного воздействия на окружающую среду, повышение энергоэффективности.",
      "Приводится иная информация, которую заявитель считает необходимым предоставить."
    ],
    //4
    [
      "Технологический показатель НДТ определяется в соответствии с пунктом 3 статьи 23 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\".",
      "Графа заполняется, если технологический показатель НДТ установлен в виде показателя концентраций загрязняющих веществ.",
      "Графа заполняется, если технологический показатель НДТ установлен в виде показателя объема и (или) массы выбросов в расчете на единицу времени.",
      "Класс опасности указывается в соответствии с гигиеническими нормативами ГН 2.1.6.3492-17 \"Предельно допустимые концентрации (ПДК) загрязняющих веществ в атмосферном воздухе городских и сельских поселений\", утвержденными постановлением Главного государственного санитарного врача Российской Федерации от 22.12.2017 N 165 (зарегистрировано Минюстом России 09.01.2018, регистрационный N 49557) с изменениями, внесенными постановлением Главного государственного санитарного врача Российской Федерации от 31.05.2018 N 37 (зарегистрировано Минюстом России 18.06.2018, регистрационный N 51367).",
      "Номер и наименование источника указывается в соответствии с результатами инвентаризации источников и выбросов загрязняющих веществ.",
      "Приводится информация, которую заявитель считает необходимым предоставить."
    ],
    //5
    [
      "Технологический показатель НДТ определяется в соответствии с пунктом 3 статьи 23 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\".",
      "Класс опасности указывается в соответствии с нормативами качества воды водных объектов рыбохозяйственного значения, в том числе нормативами предельно допустимых концентраций вредных веществ в водах водных объектов рыбохозяйственного значения, утвержденными приказом Минсельхоза России от 13.12.2016 N 552 (зарегистрирован Минюстом России 13.01.2017, регистрационный N 45203)."
    ],
    //6
    [
      "Заполняется в случае установления технологических показателей физических воздействий в порядке, предусмотренном статьей 23 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\"."
    ],
    //7
    [
      "Расчеты производятся в соответствии с:<br> постановлением Правительства Российской Федерации от 02.03.2000 N 183 \"О нормативах выбросов вредных (загрязняющих) веществ в атмосферный воздух и вредных физических воздействий на него\" (Собрание законодательства Российской Федерации, 2000, N 11, ст. 1180; 2007, N 17, ст. 2045; 2009, N 18, ст. 2248; 2011, N 9, ст. 1246; 2012, N 37, ст. 5002; 2013, N 24, ст. 2999; 2017, N 30, ст. 4674);<br> Методами расчетов рассеивания выбросов вредных (загрязняющих) веществ в атмосферном воздухе, утвержденными приказом Минприроды России от 06.06.2017 N 273 (зарегистрирован Минюстом России 10.08.2017, регистрационный N 47734).",
      "Расчеты производятся в соответствии с Методикой разработки нормативов допустимых сбросов веществ и микроорганизмов в водные объекты для водопользователей, утвержденной приказом МПР России от 17.12.2007 N 333 (зарегистрирован Минюстом России 21.02.2008, регистрационный N 11198), с изменениями, внесенными приказом Минприроды России от 22.07.2014 N 332 (зарегистрирован Минюстом России 13.08.2014, регистрационный N 33566), приказом Минприроды России от 29.07.2014 N 339 (зарегистрирован Минюстом России 02.09.2014, регистрационный N 33938), приказом Минприроды России от 15.11.2016 N 598 (зарегистрирован Минюстом России 20.01.2017, регистрационный N 45343), приказом Минприроды России от 31.07.2018 N 342 (зарегистрирован Минюстом России 31.08.2018, регистрационный N 52035)."
    ],
    //7 8
    [
      "Заполняется в соответствии с Порядком разработки и утверждения нормативов образования отходов и лимитов на их размещение, утвержденным приказом Минприроды России от 25.02.2010 N 50 (зарегистрирован Минюстом России 02.04.2010, регистрационный N 16796), с изменениями, внесенными приказом Минприроды России от 22.12.2010 N 558 \"О внесении изменений в Порядок разработки и утверждения нормативов образования отходов и лимитов на их размещение, утвержденный Приказом Минприроды России от 25 февраля 2010 года N 50\" (зарегистрирован Минюстом России 04.02.2011, регистрационный N 19719) и приказом Минприроды России от 25.07.2014 N 338 \"О внесении изменений в Порядок разработки и утверждения нормативов образования отходов и лимитов на их размещение, утвержденный приказом Минприроды России от 25.02.2010 N 50\" (зарегистрирован Минюстом России 31.12.2014, регистрационный N 35513).",
      "Порядок ведения государственного кадастра отходов, утвержденный приказом Минприроды России от 30.09.2011 N 792 (зарегистрирован Минюстом России 16.11.2011, регистрационный N 22313)."
    ],
    //8 9
    [
      "В соответствии с требованиями к содержанию программы производственного экологического контроля, порядка и сроков представления отчета об организации и о результатах осуществления производственного экологического контроля, утвержденными приказом Минприроды России от 28.02.2018 N 74 (зарегистрирован Минюстом России 03.04.2018, регистрационный N 50598).",
      "В соответствии с Федеральным законом от 23.11.1995 N 174-ФЗ \"Об экологической экспертизе\" (Собрание законодательства Российской Федерации, 1995, N 48, ст. 4556; 1998, N 16, ст. 1800; 2004, N 35, ст. 3607; N 52, ст. 5276; 2006, N 1, ст. 10; N 50, ст. 5279; N 52, ст. 5498; 2008, N 20, ст. 2260; N 26, ст. 3015; N 30, ст. 3616, ст. 3618; N 45, ст. 5148, 2009, N 1, ст. 17; N 15, ст. 1780; N 19, ст. 2283; N 51, ст. 6151; 2011, N 27, ст. 3880; N 30, ст. 4591, ст. 4594, ст. 4596; 2012, N 26, ст. 3446; N 31, ст. 4322; 2013, N 19, ст. 2331; N 23, ст. 2866; N 52, ст. 6971; 2014, N 26, ст. 3387; N 30, ст. 4220, ст. 4262; 2015, N 1, ст. 11, ст. 72; N 7, ст. 1018; N 27, ст. 3994; N 29, ст. 4347; 2016, N 1, ст. 28; 2017, N 50, ст. 7564; 2018, N 1, ст. 6; N 32, ст. 5114).",
      "В разделе приводится информация, которую заявитель считает необходимым представить дополнительно к представленной в иных разделах заявки."
    ],
    //9 10
    [
      "Согласно свидетельству о постановке на государственный учет объекта, оказывающего негативное воздействие на окружающую среду, выдаваемому юридическим лицам, индивидуальным предпринимателям, осуществляющим хозяйственную и (или) иную деятельность на указанном объекте, в соответствии со статьей 69.2 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\" (Собрание законодательства Российской Федерации, 2002, N 2, ст. 133; 2004, N 35, ст. 3607; 2005, N 1, ст. 25; N 19, ст. 1752; 2006, N 1, ст. 10; N 52, ст. 5498; 2007, N 7, ст. 834; N 27, ст. 3213; 2008, N 26, ст. 3012; N 29, ст. 3418; N 30, ст. 3616; 2009, N 1, ст. 17; N 11, ст. 1261; N 52, ст. 6450; 2011, N 1, ст. 54; N 29, ст. 4281; N 30, ст. 4590, ст. 4591, ст. 4596; N 48, ст. 6732; N 50, ст. 7359; 2012, N 26, ст. 3446; 2013, N 11, ст. 1164; N 27, ст. 3477; N 30, ст. 4059; N 52, ст. 6971, ст. 6974; 2014, N 11, ст. 1092, N 30, ст. 4220; N 48, ст. 6642; 2015, N 1, ст. 11; N 27, ст. 3994; N 29, ст. 4359; N 48, ст. 4291; 2016, N 1, ст. 24; N 15, ст. 2066; N 26, ст. 3887; N 27, ст. 4187, ст. 4286, ст. 4291; 2017, N 31, ст. 4829; 2018, N 1, ст. 47, ст. 87; N 30, ст. 4547; N 31, ст. 4841)."
    ], 
    //10 11
    [
      "Графа заполняется, если для технологии, указанной в графе 3, установлены технологические показатели НДТ в соответствии с пунктом 3 статьи 23 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\".",
      "В графе приводятся количественные и качественные показатели, которые обеспечиваются технологией, показатели воздействия на окружающую среду которой не превышают установленные технологические показатели НДТ, в том числе по следующим направлениям: снижение ресурсопотребления, снижение негативного воздействия на окружающую среду, энергоэффективности.",
      "Технологический показатель НДТ определяется в соответствии с пунктом 3 статьи 23 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\"."
    ],
    //11 12
    [
      "Технологический показатель НДТ определяется в соответствии с пунктом 3 статьи 23 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\"."
    ],
    //12 13
    [
      "Заполняется в случае установления технологических показателей НДТ в порядке, предусмотренном статьей 23 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\".",
      "В строке \"Итого\" указываются валовые выбросы (т/год) в целом по объекту, оказывающему негативное воздействие."
    ],
    //13 14
    [
      "Расчет в т/год производится суммированием т/мес."
    ],
    //14 15
    [
      "Расчет в т/год производится суммированием т/мес."
    ],
    //15 16
    [
      "Порядок ведения государственного кадастра отходов, утвержденный приказом Минприроды России от 30.09.2011 N 792 (зарегистрирован Минюстом России 16.11.2011, регистрационный N 22313)."
    ],
    //16 17
    [ 
      "В соответствии с требованиями к содержанию программы производственного экологического контроля, порядка и сроков представления отчета об организации и о результатах осуществления производственного экологического контроля, утвержденными приказом Минприроды России от 28 февраля 2018 года N 74 (зарегистрирован Минюстом России 03.04.2018, регистрационный N 50598).",
      "Заполняются при невозможности соблюдения технологических нормативов, нормативов допустимых выбросов высокотоксичных веществ, веществ, обладающих канцерогенными, мутагенными свойствами (веществ I, II классов опасности) в соответствии со статьей 23.1 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\".",
      "Заполняются при невозможности соблюдения технологических нормативов, нормативов допустимых сбросов высокотоксичных веществ, веществ, обладающих канцерогенными, мутагенными свойствами (веществ I, II классов опасности) в соответствии со статьей 23.1 Федерального закона от 10.01.2002 N 7-ФЗ \"Об охране окружающей среды\"."
    ]
  ];


export const SchemesGenerator = {
  withValidator: function(array, validator){
    return array.map((element)=>{
      element.validator = validator
      return element
    })
  },

  defaultBaseYear: 2021,

  application: function(baseYear, kerRange) {
    if (!(baseYear===0) && !Number(baseYear))
      baseYear = this.defaultBaseYear
    else 
      baseYear = Number(baseYear)
    return {label:"Заполнение формы заявки на получение КЭР", schemas:[
       {
          "id": "tbl-1-1",
          "label": "Виды и объём производимой продукции",
          "headers": [commonHeaders.numbnerInOrder, {
            "label": "Наименование вида производимой продукции (товара)",
            "ref": [1, 1]
          }, {
            "label": "Код производимой продукции (товара)",
            "ref": [1, 1],
            "merge": 2
          }, commonHeaders.measureUnit(), {
            "label": "Максимальный объём производимой продукции (товара) согласно проектной документации",
            "validator": commonValidators.rational,
            "merge": 1
          }, {
            "label": "Планируемый объем производства продукции (товара) по годам",
            "ref": [1, 3],
            "children": this.withValidator(commonHeaders.yearsRange(baseYear, baseYear+6), commonValidators.rational)
          }]
        }, {
          "id": "tbl-1-2",
          "label": "Информация об использовании сырья",
          "check": true,
          "ref": [1, 3],
          "headers": [
            commonHeaders.numbnerInOrder, 
            { "label": "Наименование сырья", "ref": [1, 1] }, 
            { "label": "Код сырья", "ref": [1, 1] }, 
            commonHeaders.measureUnit(), 
            { "label": "Максимальный объём используемого сырья в год", "validator": commonValidators.rational }, 
            {
              "label": "Планируемый объём использования сырья по годам",
              "ref": [1, 2],
              "children": commonHeaders.yearsRange(baseYear, baseYear + 6).map((child) => {
                child.validator = commonValidators.rational
                return child
              })
            }
          ]
        }, {
          "id": "tbl-1-3",
          "label": "Информация об использовании воды",
          "ref": [1, 4],
          "headers": [commonHeaders.numbnerInOrder, {
            "label": "Максимальное количество используемой воды",
            "children": this.withValidator([{ "label": "куб м/сут." }, { "label": "тыс. куб м/год" }], commonValidators.rational)
          }, { "label": "Источник водоснабжения" }, {
            "label": "Планируемое использование воды по годам",
            "ref": [1, 2],
            "children": this.withValidator(commonHeaders.yearsRange(baseYear, baseYear + 6).map((child) => {
                child.validator = commonValidators.rational
                return child
              }), commonValidators.rational)
          }]
        }, {
          "id": "tbl-1-4",
          "label": "Информация об использовании электрической энергии",
          "headers": [
            commonHeaders.numbnerInOrder, commonHeaders.measureUnit("кВт"), 
            { "label": "Максимальное количество потребляемой электрической энергии в год", "validator": commonValidators.rational }, 
            {
              "label": "Планируемое использование электрической энергии по годам",
              "ref": [1, 2],
              "children": this.withValidator(commonHeaders.yearsRange(baseYear, baseYear + 6), commonValidators.rational)
            }
          ]
        }, {
          "id": "tbl-1-5",
          "label": "Информация об использовании тепловой энергии",
          "headers": [
            commonHeaders.numbnerInOrder, 
            { "label": "Вид тепловой энергии" }, 
            commonHeaders.measureUnit("м<sup>3</sup>/ч"), 
            { "label": "Максимальное количество использование тепловой энергии в год", "validator": commonValidators.rational }, 
            {
              "label": "Планируемое использование тепловой энергии по годам",
              "ref": [1, 2],
              "children": this.withValidator(commonHeaders.yearsRange(baseYear, baseYear + 6), commonValidators.rational)
            }
          ]
        },

        //section 1.6. //ref 2
        {
          "id": "tbl-1-6-1",
          "label": "Сведения об авариях, повлекших негативное воздействие на окружающую среду, произошедших за " + (baseYear - 6) + " - " + baseYear + " годы",
          "canLeftEmpty": true,
          "headers": [
            commonHeaders.numbnerInOrder, 
            { "label": "Дата возникновения аварии" }, 
            { "label": "Дата ликвидации аварии" }, 
            { "label": "Размер вреда, причиненного окружающей среде, тыс. руб", "validator":commonValidators.rational }, 
            { "label": "Краткая характеристика аварии, причины возникновения, последствия для компонентов природной среды", "ref": [2, 2] },
            { "label": "Основные мероприятия по ликвидации аварии" }
          ]
        }, {
          "id": "tbl-1-6-2",
          "canLeftEmpty": true,
          "label": "Сведения об инцидентах, повлекших негативное воздействие на окружающую среду, произошедших за " + (baseYear - 6) + " - " + baseYear + " годы",
          "headers": [
            commonHeaders.numbnerInOrder, 
            { "label": "Дата возникновения инцидента" }, 
            { "label": "Дата ликвидации инцидента" },
            { "label": "Размер вреда, причиненного окружающей среде, тыс. руб", "validator": commonValidators.rational }, 
            { "label": "Краткая характеристика инцидента, причины возникновения, последствия для компонентов природной среды", "ref": [2, 2] }, 
            { "label": "Основные мероприятия по ликвидации инцидента" }
          ]
        },
        //1.7
        {
          "id": "tbl-1-7",
          "label": "Информация о реализации программы повышения экологической эффективности",
          "canLeftEmpty": true,
          "ref": [2, 3],
          "headers": [
            commonHeaders.numbnerInOrder, 
            { "label": "Наименование мероприятия" }, 
            {
              "label": "Срок выполнения",
              "children": [{ "label": "Начало" }, { "label": "Конец" }]
            }, 
            { "label": "Объем финансирования, тыс. руб", "validator": commonValidators.rational }, 
            { "label": "Источники финансирования" }, 
            { "label": "Объем выполненных работ на дату представления заявки" }, 
            { "label": "Результат выполненных работ на дату представления заявки" }
          ]
        },
        //раздел 2 //ref 3
        {
          "id": "tbl-2-1",
          "label": "Сведения о применяемых на объекте," + " оказывающем негативное воздействие на окружающую среду" + " (далее также - объект ОНВ) технологиях, показатели" + " воздействия на окружающую среду которых не превышают" + " установленные технологические показатели наилучших" + " доступных технологий (далее - НДТ)",
          "fixedRowNumber": true,
          "headers": [
            commonHeaders.numbnerInOrder, 
            { "label": "Наименование информационно-технического справочника по наилучшим доступным технологиям" }, 
            { "label": "Описание технологий, показатели воздействия на окружающую среду которых не превышают установленные технологические показатели НДТ", readOnly: true }, 
            { "label": "Технологические показатели", "ref": [3, 1] }, 
            { "label": "Реквизиты документа, которым установлены технологические показатели НДТ", "ref": [3, 1] }, 
            { "label": "Цели внедрения НДТ или иной технологии, показатели воздействия на окружающую среду которых не превышают установленные технологические показатели НДТ", "ref": [3, 2] }, 
            { "label": "Дата внедрения" }
          ]
        },
        //2.1. Расчеты технологических нормативов выбросов
        {
          "id": "tbl-2-2-1",
          "label": "Сведения о стационарных источниках, входящих" + " в состав объекта ОНВ, для которых установлены" + " технологические показатели выбросов НДТ",
          "fixedRowNumber": true,
          "canLeftEmpty": true,
          "headers": [
            commonHeaders.numbnerInOrder, 
            { "label": "Наименование стационарного источника (их совокупности)" }, 
            { "label": "Количество стационарных источников (их совокупности), входящих в состав объекта ОНВ" },
            { "label": "Количество загрязняющих веществ, для которых установлены технологические показатели выбросов НДТ" }, 
            { "label": "Примечание", "ref": [3, 3] }
          ]
        }, //ref 4

        {
          "id": "tbl-2-2-2",
          "label": "Показатели для расчета технологических нормативов выбросов",
          "fixedRowNumber": true,
          "canLeftEmpty": true,
          "headers": [{
              ...commonHeaders.numbnerInOrder,
              merge: false
            },
            //{ "label": "N п/п", auto: function auto(position) {
            //  return position.row;
            //} }, 
            {
            "label": "Характеристика стационарного источника (их совокупности)",
            "children": [
              { "label": "Наименования", merge: 1 }, 
              { "label": "Кол-во источников", "validator": commonValidators.number, merge: 2 }, 
              { "label": "Мощность", "children": [{ "label": "Ед. изм.", merge: 2 }, { "label": "Величина", "validator":commonValidators.rational, merge: 2 }] }
            ]
          }, {
            "label": "Загрязняющее вещество",
            "children": [{ "label": "Наименование" }, { "label": "Класс опасности", ref: [4,4] }]
          }, {
            "label": "Технологический показатель НДТ",
            "children": [{ "label": "Ед. изм", auto: () => "мг/нм<sup>3</sup>" }, { "label": "Величина", "validator": commonValidators.rational }],
            "ref": [4, 1]
          }, {
            "label": "Технологический показатель стационарного источника (их совокупности)",
            "children": [{ "label": "Ед. изм", auto: () => "мг/нм<sup>3</sup>" }, { "label": "Величина", "validator" : commonValidators.rational }]
          }, {
            "label": "Расход (объем) газовоздушной смеси источника выбросов",
            "children": [{ "label": "Ед. изм", auto: () => "нм<sup>3</sup>/год", merge: 2 }, { "label": "Величина", "validator" : commonValidators.rational, merge: 2 }],
            "ref": [4, 2]
          }, {
            "label": "Время работы источника(ов) выбросов, час/год",
            "validator" : commonValidators.rational,
            merge: 2,
            "ref": [4, 3]
          }, {
            "label": "Технологический норматив выброса, т/год",
            "children": [
              { "label": "По стационарному источнику (их совокупности)", "validator" : commonValidators.rational }, 
              { "label": "по ОНВ в целом", "validator" : commonValidators.rationa, merge: 2 }
            ]
          }],
          fixedRowNumber: true,
        }, {
          "id": "tbl-2-2-3",
          "label": "Технологические показатели источников выбросов загрязняющих веществ, обеспечивающие выполнение технологических нормативов выбросов",
          "fixedRowNumber": true,
          "canLeftEmpty": true,
          "headers": [
            { "label": "Наименование стационарного источника (их совокупности)", merge: true }, 
            { "label": "Номер источника выброса", ref: [4, 5] }, 
            { "label": "Наименование источника выброса", ref: [4, 5] }, 
            {
              "label": "Загрязняющее вещество",
              "children": [{ "label": "Наименование" }, { "label": "Класс опасности", "ref": [4, 4] }]
            }, 
            {
              "label": "Максимальное значение технологического показателя источника выбросов",
              "children": [
                { "label": "мг/куб.м", "validator" : commonValidators.rational }, 
                { "label": "г/сек", "validator" : commonValidators.rational }
              ]
            }, 
            { "label": "Примечание", "ref": [4, 6] }
          ]
        },
        //2.3 Расчеты технологических нормативов сбросов //ref 5
        {
          "id": "tbl-2-3-1",
          "label": "Сведения о стационарных источниках (их совокупности), входящих в состав объекта ОНВ, для которых установлены технологические показатели сбросов НДТ",
          "canLeftEmpty": true,
          "headers": [
            commonHeaders.numbnerInOrder,
            { "label": "Наименование стационарного источника (их совокупности)" }, 
            { "label": "Количество стационарных источников (их, совокупности), входящих в состав объекта ОНВ", "validator" : commonValidators.number }, 
            { "label": "Количество загрязняющих веществ, для которых установлены технологические показатели сбросов НДТ", "ref": [5, 1] }, 
            { "label": "Примечание" }
          ]
        }, {
          "id": "tbl-2-3-2",
          "canLeftEmpty": true,
          "label": "Показатели для расчета технологических нормативов сбросов",
          "headers": [{ "label": "N п/п", auto: function auto(position) {
              return position.row;
            } }, {
            "label": "Характеристика стационарного источника (их совокупности)",
            "children": [
              { "label": "Наименование (номер выпуска)" }, 
              { "label": "Кол-во" }, 
              { "label": "Мощность", "children": [
                  { "label": "Ед. изм." }, { "label": "Величина", "validator" : commonValidators.rational }
                ] 
              }
            ]
          }, {
            "label": "Загрязняющее вещество",
            "children": 
              [
                { "label": "Наименование" }, 
                { "label": "Класс опасности", ref: [5, 2] }
              ]
          }, {
            "label": "Технологический показатель НДТ",
            "children": [{ "label": "Ед. изм" }, { "label": "Величина", "validator" : commonValidators.rational }],
            "ref": [4, 1]
          }, {
            "label": "Технологический показатель, устанавливаемый для стационарного источника (их совокупности)",
            "children": [{ "label": "Ед. изм" }, { "label": "Величина", "validator" : commonValidators.rational }]
          }, {
            "label": "Расход сточных вод",
            "children": [{ "label": "Ед. изм" }, { "label": "Величина", "validator" : commonValidators.rational }],
            "ref": [4, 2]
          }, {
            "label": "Время работы источника(ов) сброса, час/год",
            "ref": [4, 3]
          }, {
            "label": "Технологический норматив сброса, т/год",
            "children": [
              { "label": "По стационарному источнику (их совокупности)", "validator" : commonValidators.rational }, 
              { "label": "по ОНВ в целом", "validator" : commonValidators.rational }
            ]
          }]
        }, 
        //ref 6
        {
          "id": "tbl-2-3-3",
          "label": "Технологические показатели источников сбросов загрязняющих веществ, обеспечивающие выполнение технологических нормативов сбросов",
          "canLeftEmpty": true,
          "headers": [
            { "label": "Наименование стационарногои источника (их совокупности)" }, 
            { "label": "Порядковый номер источника сброса (выпуска)" }, 
            { "label": "Наименование водного объекта" }, 
            {
              "label": "Загрязняющее вещество",
              "children": [{ "label": "Наименование" }, { "label": "Класс опасности" }]
            }, {
              "label": "Максимальное значение технологичекого показателя источника сбросов",
              "children": [
                { "label": "мг/ куб.м", "validator" : commonValidators.rational }, 
                { "label": "г/ч", "validator" : commonValidators.rational }
              ]
            }, { "label": "Примечание" }]
        },
        //2.4. Технологические нормативы физических воздействий [6,1] <1>
        {
          "id": "tbl-2-4-1",
          "label": "Сведения об объектах, входящих в состав объекта ОНВ",
          "headers": [
            commonHeaders.numbnerInOrder, 
            { "label": "Наименование стационарного источника (их совокупности)" }, 
            { "label": "Количество стационарных источников (их совокупности), входящих в состав объекта ОНВ", "validator" : commonValidators.number }, 
            { "label": "Вид физического воздействия" }
          ]
        }, {
          "id": "tbl-2-4-2",
          "label": "Технологические нормативы физических воздействий",
          "headers": [
            commonHeaders.numbnerInOrder, 
            { "label": "Наименование стационарного источника (их совокупности)" }, 
            { "label": "Наименование вида физического воздействия на окружающую среду" }, 
            {
              "label": "Технологический норматив физического воздействия на окружающую среду",
              "children": [{ "label": "Единица измерения", merge: true }, { "label": "Величина", "validator" : commonValidators.rational, merge: true }]
            }
          ]
        },
        //раздел 5
        {
          "id": "tbl-5-1",
          "label": "Обоснование нормативов образования отходов",
          "canLeftEmpty": true,
          "ref": [8,1],
          "headers": [
            commonHeaders.numbnerInOrder,
            { "label": "Наименование вида отходов" },
            { "label": "Код по ФККО", "validator": commonValidators.number },
            { "label": "Класс опасности", 
              "validator": commonValidators.and(
                commonValidators.number,
                function(str){
                  let n = Number(str)
                  return n >= 1 && n <= 5 
                }
              )
            },
            { "label": "Наименование технологического процесса, в результате которого образуются отходы" },
            { 
              "label": "Норматив образования отходов, т/ед. производимой продукции (оказываемых услуг, выполняемых работ)",
              "validator": commonValidators.rational
            },
            {
              "label": "Объем ежегодно производимой продукции (оказываемых услуг, выполняемых работ)",
              "validator": commonValidators.rational
            },
            {
              "label": "Предлагаемое ежегодное образование отходов, т/год",
              "validator": commonValidators.rational
            }
          ]
        },
        {
          "id": "tbl-5-2",
          "label": "Обоснование запрашиваемых лимитов на размещение отходов производства и потребления",
          "canLeftEmpty": true,
          "ref": [8,1],
          "headers": [
            commonHeaders.numbnerInOrder,
            { "label": "Наименование вида отходов по ФККО" },
            { "label": "Код по ФККО", "validator": commonValidators.number },
            { 
              "label": "Отходы, передаваемые для размещения другим индивидуальным предпринимателям, юридическим лицам",
              "children": [
                {"label": "Наименование объекта размещения отходов"},
                {"label": "Номер объекта размещения отходов в ГРОРО2"},
                {
                  "label": "Лимиты на размещение отходов, тонн", 
                  "children": [
                    {
                      "label" : "Всего", 
                      "validator": commonValidators.rational,
                    },
                    {
                      "label": "В том числе по годам",
                      "children": commonHeaders.yearsRange(baseYear, baseYear + 6).map((child) => {
                        child.validator = commonValidators.rational
                        return child
                      })
                    }
                  ]
                }
              ]
            }
          ]
        },
        //Группа из трёх таблиц ref 7
        {
          "id": "tbl-5-3",
          "label": "Сводные данные по образованию отходов производства и потребления и запрашиваемым лимитам на их размещение",
          "canLeftEmpty": true,
          "ref": [8,1],
          "sections": [
            {
              "headers": [
                commonHeaders.numbnerInOrder,
                {"label": "Сведения об образовании отходов производства и потребления", "children": [
                  {"label": "Наименование вида отходов по федеральному классификационному каталогу отходов, далее - ФККО"},
                  {"label": "Код по ФККО"},
                  {"label": "Норматив образования отходов", "children": [
                    {"label": "Единица измерения"}, {"label": "Величина", "validator" : commonValidators.rational} 
                  ]},
                  {"label": "Максимальное годовое количество образования отходов, тонн", "validator" : commonValidators.rational}
                ]}
              ]
            },
            {
              "headers": [
                commonHeaders.numbnerInOrder,
                {
                "label": "Отходы, передаваемые для размещения другим индивидуальным предпринимателям, юридическим лицам",
                "children": [{
                  "label": "Наименование объекта размещения отходов"
                }, {
                  "label": "Номер объекта размещения отходов в государственном реестре объектов размещения отходов, далее - ГРОРО",
                }, {
                  "label": "Лимиты на размещение отходов, тонн",
                  "children": [{
                    "label": "Всего", "validator" : commonValidators.rational
                  }, {
                    "label": "В том числе по годам",
                    "children": this.withValidator(commonHeaders.yearsRange(baseYear, baseYear + 6), commonValidators.rational)
                  }]
                }]
              }],
              "widths": ["88pt", "85pt", "31pt", "34pt", "34pt", "34pt", "40pt", "34pt", "34pt", "40pt"]
            },
            {
              "headers": [
                commonHeaders.numbnerInOrder,
                {
                "label": "Отходы, размещаемые на самостоятельно эксплуатируемых (собственных) объектах размещения отходов",
                "children": [{
                  "label": "Наименование объекта размещения отходов"
                }, {
                  "label": "Номер объекта размещения отходов в ГРОРО"
                }, {
                  "label": "Лимиты на размещение отходов, тонн",
                  "children": [{
                    "label": "Всего",
                    "validator" : commonValidators.rational
                  }, {
                    "label": "В том числе по годам",
                    "children":  this.withValidator(commonHeaders.yearsRange(baseYear, baseYear+6), commonValidators.rational)
                  }]
                }]
              }],
              "widths": ["88pt", "85pt", "31pt", "34pt", "34pt", "34pt", "40pt", "34pt", "34pt", "40pt"]
            }
          ]
          
        }, 
    ].map(function (scheme) {
      return scheme.rows = SchemeUtils.preprocess(scheme);
    })};  
  },

  permission: function(baseYear, kerRange){
    if (!(baseYear===0) && !Number(baseYear))
      baseYear = this.defaultBaseYear
    return {label:"Заполнение формы КЭР", schemas:[
      //section 1
      //ref 10
      {
        "id": "tbl-6-1",
        "label": "Сведения о применяемых на объекте, оказывающем негативное воздействие на окружающую среду (далее также - объект ОНВ), наилучших доступных технологиях и (или) технологиях, показатели воздействия на окружающую среду которых не превышают установленные технологические показатели наилучших доступных технологий (далее - НДТ)",
        "headers": [
          commonHeaders.numbnerInOrder, {
            "label": "Наименование информационно-технического справочника по наилучшим доступным технологиям"
          }, {
          "label": "Описание наилучших доступных технологий и (или) технологий, показатели воздействия на окружающую среду которых не превышают установленные технологические показатели НДТ"
          }, {
          "label": "Технологические показатели НДТ", "ref": [11, 1]
          }, {
          "label": "Реквизиты документа, которым установлены технологические показатели НДТ", "ref": [11, 1]
          }, {
          "label": "Цели внедрения НДТ или иной технологии показатели воздействия на окружающую среду которых не превышают установленные технологические показатели НДТ", "ref": [11, 2]
          }, {
          "label": "Дата внедрения"
          }
        ],
          "widths": ["27pt", "91pt", "133pt", "74pt", "94pt", "111pt", "54pt"]
      }, {
        "id": "tbl-6-2-1",
        "label": "Технологические нормативы выбросов",
        "headers": [commonHeaders.numbnerInOrder, {
          "label": "Характеристика стационарного источника (их совокупности)",
          "children": [{
            "label": "Наименование"
          }, {
            "label": "Кол-во источников", "validator" : commonValidators.number
          }, {
            "label": "Мощность",
            "children": [{
              "label": "Ед. изм."
            }, {
              "label": "Величина", "validator" : commonValidators.rational
            }]
          }]
        }, {
          "label": "Загрязняющее вещество",
          "children": [{
            "label": "Наименование"
          }, {
            "label": "Класс опасности"
          }]
        }, {
          "label": "Технологический показатель НДТ", "ref": [11, 3],
          "children": [{
            "label": "Ед. изм."
          }, {
            "label": "Величина", "validator" : commonValidators.rational
          }]
        }, {
          "label": "Технологический показатель стационарного источника (их совокупности)",
          "children": [{
            "label": "Ед. изм."
          }, {
            "label": "Величина", "validator" : commonValidators.rational
          }]
        }, {
          "label": "Технологический норматив выброса, т/год",
          "children": [{
            "label": "по стационарному источнику (их совокупности)", "validator" : commonValidators.rational
          }, {
            "label": "по ОНВ в целом", "validator" : commonValidators.rational
          }]
        }],
        "widths": ["28pt", "53pt", "43pt", "36pt", "57pt", "62pt", "57pt", "50pt", "57pt", "57pt", "57pt", "76pt", "44pt"]
      }, 
      //ref 11
      {
        "id": "tbl-6-2-2",
        "label": "Технологические нормативы сбросов",
        "headers": [{
          "label": "Наименование стационарного источника (их совокупности)"
        }, {
          "label": "Номер источника выброса"
        }, {
          "label": "Наименование источника выброса"
        }, {
          "label": "Загрязняющее вещество",
          "children": [{
            "label": "Наименование"
          }, {
            "label": "Класс опасности"
          }]
        }, {
          "label": "Максимальное значение технологического показателя источника выбросов",
          "children": [{
            "label": "мг/куб. м", "validator" : commonValidators.rational
          }, {
            "label": "г/сек", "validator" : commonValidators.rational
          }]
        }, {
          "label": "Примечание"
        }],
        "widths": ["79pt", "57pt", "62pt", "60pt", "48pt", "48pt", "43pt", "57pt"]
      }, {
        "id": "tbl-6-3-1",
        "label": "Технологические нормативы сбросов",
        "headers": [commonHeaders.numbnerInOrder, {
          "label": "Характеристика стационарного источника (их совокупности)",
          "children": [{
            "label": "Наименование"
          }, {
            "label": "Количество", "validator" : commonValidators.number
          }, {
            "label": "Мощность",
            "children": [{
              "label": "Ед. изм."
            }, {
              "label": "Величина", "validator" : commonValidators.rational
            }]
          }]
        }, {
          "label": "Загрязняющее вещество",
          "children": [{
            "label": "Наименование"
          }, {
            "label": "Класс опасности"
          }]
        }, {
          "label": "Технологический показатель НДТ", "ref": [12, 1],
          "children": [{
            "label": "Ед. изм."
          }, {
            "label": "Величина", "validator" : commonValidators.rational
          }]
        }, {
          "label": "Технологический показатель стационарного источника (их совокупности)",
          "children": [{
            "label": "Ед. изм."
          }, {
            "label": "Величина", "validator" : commonValidators.rational
          }]
        }, {
          "label": "Технологический норматив сброса, т/год",
          "children": [{
            "label": "по стационарному источнику (их совокупности)", "validator" : commonValidators.rational
          }, {
            "label": "по ОНВ в целом", "validator" : commonValidators.rational
          }]
        }],
        "widths": ["26pt", "43pt", "45pt", "36pt", "48pt", "48pt", "54pt", "36pt", "43pt", "43pt", "45pt", "62pt", "48pt"]
      }, {
        "id": "tbl-6-3-2",
        "label": "Технологические показатели источников сбросов загрязняющих веществ для контроля соблюдения технологических нормативов сбросов",
        "headers": [{
          "label": "Наименование стационарного источника (их совокупности)"
        }, {
          "label": "Порядковый номер источника сброса", readOnly: true
        }, {
          "label": "Наименование водного объекта"
        }, {
          "label": "Загрязняющее вещество",
          "children": [{
            "label": "Наименование"
          }, {
            "label": "Класс опасности"
          }]
        }, {
          "label": "Максимальное значение технологического показателя источника сбросов",
          "children": [{
            "label": "мг/куб. м", "validator" : commonValidators.rational
          }, {
            "label": "г/ч", "validator" : commonValidators.rational
          }]
        }, {
          "label": "Примечание"
        }],
        "widths": ["79pt", "57pt", "62pt", "60pt", "48pt", "48pt", "43pt", "57pt"]
      }, 
      //ref 12
      {
        "id": "tbl-6-4",
        "label": "Технологические нормативы физических воздействий",
        "ref": [13, 1],
        "headers": [commonHeaders.numbnerInOrder, {
          "label": "Наименование стационарного источника (их совокупности)"
        }, {
          "label": "Наименование вида физического воздействия"
        }, {
          "label": "Технологический норматив физического воздействия",
          "children": [{
            "label": "Единица измерения"
          }, {
            "label": "Величина", "validator" : commonValidators.rational
          }]
        }],
        "widths": ["25pt", "102pt", "108pt", "105pt", "113pt"]
      },

      {
        "id": "tbl-7-1",
        "label" : "Перечень и количество высокотоксичных веществ, веществ, обладающих канцерогенными, мутагенными свойствами (веществ I, II классов опасности), разрешенных к выбросу в атмосферный воздух",
        "headers": [
          commonHeaders.numbnerInOrder,
          {"label": "Наименование вещества"},
          {"label" : "Класс опасности"},
          {
            "label" : "Установленный норматив допустимого выброса",
            "children": [
                {"label" : "г/с", "validator" : commonValidators.rational, "summary" : "X"},
                {"label" : "т/г", "validator" : commonValidators.rational, "summary" : commonSummaries.columnTotal},
                {
                  "label" : "С разбивкой по годам, т/г",
                  "children" : this.withValidator(commonHeaders.yearsRange(baseYear - 6, baseYear), commonValidators.rational).map((children) => {
                    children.summary = commonSummaries.columnTotal
                    return children
                  })
                }
            ]
          }
        ],
        "summary" : {
          "label": "Итого",
          "ref" : [13,2],
          "shift": 2
        }
        
      },

      //Две таблицы с summary. Пока не решено как их отображать
      //ref 13
      {
        "id": "tbl-8-1",
        "label": "Нормативы допустимого сброса высокотоксичных веществ, веществ, обладающих канцерогенными, мутагенными свойствами (веществ I, II классов опасности) в водный объект",
        "sections": [{
          "headers": [commonHeaders.numbnerInOrder, {
            "label": "Наименование вещества"
          }, {
            "label": "Класс опасности"
          }, {
            "label": "Установленный норматив допустимого сброса веществ мг/куб. дм"
          }, {
            "label": "Установленный норматив допустимого сброса веществ",
            "children": [{
              "label": "январь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "февраль",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "март",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "апрель",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "май",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }]
          }],
          "widths": ["26pt", "68pt", "51pt", "62pt", "31pt", "40pt", "31pt", "45pt", "31pt", "43pt", "34pt", "45pt", "33pt", "43pt"]
        }, {
          "headers": [{
            "label": "Установленный норматив допустимого сброса веществ",
            "children": [{
              "label": "июнь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "июль",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "август",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "сентябрь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "октябрь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "ноябрь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "декабрь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "Установленный норматив допустимого сброса веществ", 
              "ref": [14, 1], 
              "auto": commonSummaries.rowSummary(Array(12).fill().map((_, index) => {return index*2+5}))
            }]
          }],
          "widths": ["34pt", "51pt", "37pt", "45pt", "31pt", "45pt", "31pt", "45pt", "32pt", "43pt", "37pt", "43pt", "40pt", "43pt", "74pt"]
        }]
      },

      {
        "label": "Норматив допустимого выброса высокотоксичных веществ, веществ, обладающих канцерогенными, мутагенными свойствами (веществ I, II классов опасности) в атмосферный воздух по конкретным источникам и веществам",
        "id" : "tbl-7-2",
        "headers" : [
          commonHeaders.numbnerInOrder,
          {
            "label": "Производства, цех, участок",
          },
          {
            "label": "N источника"
          },
          {
            "label": "Установленый норматив допустимого выброса",
            "children": [
              {"label": ("Существующее положение " + baseYear),
              "children": [
                {"label" : "г/с",   "validator" : commonValidators.rational, "summary" : "X"},
                {"label" : "т/год", "validator" : commonValidators.rational, "summary" : commonSummaries.columnTotal}
              ]}, {
                "label":"с разбивкой по годам",
                "children": commonHeaders.yearsRange(baseYear, baseYear + 6).map(function(element){
                  element.children = [
                    {"label" : "г/с",   "validator" : commonValidators.rational, "summary" : "X"},
                    {"label" : "т/год", "validator" : commonValidators.rational, "summary" : commonSummaries.columnTotal}
                  ]
                  return element
                })
              }
            ]
          },
        ],
        "group" : {
          "header" : {
            "label": "Наименование и код загрязняющего вещества",
            "editable": true,
            "colspan": "all"
          },
          "summary" : {
            "id": "totalBySubstance",
            "label" : "Всего по загрязняющему веществу",
            "shift": 1
          }
        },
        "summary" : {
          "id": "total",
          "label": "Итого",
          "ref" : [13,2],
          "shift": 0
        },
        "emptyRowUnderHeader": true
      },

      //Группа из двух таблиц
      // {
      //   "id": "tbd-8-1",
      //   "label": "",

      // },

      // {
      //   "id": "tbd-8-1",
      //   "label": "",

      // },
      ////
      //Группа из двух таблиц

      {
        "id": "tbl-8-2",
        "label": "Нормативы допустимого сброса веществ в водный объект для объекта централизованной системы водоотведения поселений или городских округов",
        "sections": [{
          "headers": [commonHeaders.numbnerInOrder, {
            "label": "Наименование вещества"
          }, {
            "label": "Класс опасности"
          }, {
            "label": "Установленный норматив допустимого сброса веществ мг/куб. дм", "validator" : commonValidators.rational
          }, {
            "label": "Установленный норматив допустимого сброса веществ",
            "children": [{
              "label": "январь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "февраль",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "март",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "апрель",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "май",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }]
          }],
          "widths": ["26pt", "68pt", "51pt", "62pt", "31pt", "40pt", "31pt", "45pt", "31pt", "43pt", "34pt", "45pt", "33pt", "43pt"]
        }, {
          "headers": [{
            "label": "Установленный норматив допустимого сброса веществ",
            "children": [{
              "label": "июнь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "июль",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "август",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "сентябрь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "октябрь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "ноябрь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "декабрь",
              "children": [{
                "label": "г/ч", "validator" : commonValidators.rational
              }, {
                "label": "т/мес.", "validator" : commonValidators.rational
              }]
            }, {
              "label": "Установленный норматив допустимого сброса веществ", 
              "ref": [15, 1], 
              "auto": commonSummaries.rowSummary(Array(12).fill().map((_, index) => {return index*2+5}))
            }]
          }],
          "widths": ["34pt", "43pt", "37pt", "37pt", "31pt", "45pt", "31pt", "37pt", "32pt", "37pt", "31pt", "37pt", "34pt", "34pt", "82pt"]
        }]
      },
      {
        "id": "tbl-8-3",
        "label": "Нормативы образования отходов производства и потребления и лимиты на их размещение",
        "sections": [{
          "headers": [commonHeaders.numbnerInOrder, {
            "label": "Наименование вида отходов по федеральному классификационному каталогу отходов, далее - ФККО", "ref": [16, 1]
          }, {
            "label": "Код по ФККО", "ref": [16, 1]
          }, {
            "label": "Норматив образования отходов",
            "children": [{
              "label": "Единица измерения"
            }, {
              "label": "Величина", "validator" : commonValidators.rational
            }]
          }, {
            "label": "Максимальное годовое количество образования отходов, тонн"
          }],
          "widths": ["36pt", "113pt", "62pt", "74pt", "60pt", "108pt"]
        }, {
          "headers": [{
            "label": "Отходы, передаваемые для размещения другим индивидуальным предпринимателям, юридическим лицам",
            "children": [{
              "label": "Наименование объекта размещения отходов"
            }, {
              "label": "Номер объекта размещения отходов в государственном реестре объектов размещения отходов, далее - ГРОРО", "ref": [16,1]
            }, {
              "label": "Лимиты на размещение отходов, тонн",
              "children": [{
                "label": "Всего", "validator" : commonValidators.rational
              }, {
                "label": "В том числе по годам",
                "children": this.withValidator(commonHeaders.yearsRange(baseYear - 6, baseYear), commonValidators.rational)
              }]
            }]
          }],
          "widths": ["88pt", "85pt", "31pt", "34pt", "34pt", "34pt", "40pt", "34pt", "34pt", "40pt"]
        }, {
          "headers": [{
            "label": "Отходы, размещаемые на самостоятельно эксплуатируемых (собственных) объектах размещения отходов",
            "children": [{
              "label": "Наименование объекта размещения отходов"
            }, {
              "label": "Номер объекта размещения отходов в ГРОРО", "ref": [16,1]
            }, {
              "label": "Лимиты на размещение отходов, тонн",
              "children": [{
                "label": "Всего", "validator" : commonValidators.rational
              }, {
                "label": "В том числе по годам",
                "children": this.withValidator(commonHeaders.yearsRange(baseYear - 6, baseYear), commonValidators.rational)
              }]
            }]
          }],
          "widths": ["88pt", "85pt", "31pt", "34pt", "34pt", "34pt", "40pt", "34pt", "34pt", "40pt"]
        }]
      },
      ].map(function (scheme) {
        return scheme.rows = SchemeUtils.preprocess(scheme);
      })};
  }
}